import { Injectable } from '@angular/core';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { HttpService } from '../shared/services/http.service';
import { map, tap } from 'rxjs';
import { UserPlanDevDTO } from '../models/UserPlanDevDTO.model';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { ResponseBase } from '../models/ResponseBase';

@Injectable({
  providedIn: 'root'
})
export class AssignPlanService {

  constructor(private httpService: HttpService) { }

  getMastersById(data: MasterdataRequestDTO) {
    return this.httpService.getMastersById(data).pipe(
      tap((data) => {
      })
    );
  }

  assignPlan(usrPlanDev: UserPlanDevDTO) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.ASSIGN_PLAN, usrPlanDev).pipe(
      tap((data) => {
      })
    );
  }

  updateUserPlan(usrPlanDev: UserPlanDevDTO) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.UPDATE_USER_PLAN, usrPlanDev).pipe(
        tap((data) => {
      })
      );
  }
}
